module.exports = __webpack_public_path__ + "media/images/global/projects/english_language_arts-2e7b3990f1f0a7186b48530d386876a2.svg";